import React from 'react'
import Image from '../pdf/Image'
import { useEnv } from '../../utils/contexts/EnvContext'

const MapStaticImage = ({ latitude, longitude, zoom, ...props }) => {
  const env = useEnv()
  const googleApiKey = env?.REACT_APP_GOOGLE_API_KEY
  const url = getMapStaticImageUrl({ latitude, longitude, zoom, googleApiKey })
  return <Image src={url} {...props} />
}

const getMapStaticImageUrl = ({ latitude, longitude, zoom, googleApiKey }) => {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=1200x300&maptype=roadmap&markers=color:0x9728fd%7C${latitude},${longitude}&key=${googleApiKey}`
}

export default MapStaticImage
